import { Modal as AntModal, Form, Input } from "antd";

import { DatePicker } from "../date-picker";
import { UserSelect } from "components/selects/user-select";
import { useScheduleOpportunityFollowup } from "data/use-followups";
import {
  CREATE_OPPORTUNITY_FOLLOWUP_MODAL,
  useLayoutStore,
} from "stores/layout";
import { toUnixDate } from "utils/unix-date";
import { useOnChange } from "../../hooks/use-on-change";

export const AssignOpportunityFollowupModal = () => {
  const layoutState = useLayoutStore(
    (state) => state[CREATE_OPPORTUNITY_FOLLOWUP_MODAL]
  );

  const close = (afterClose) =>
    useLayoutStore
      .getState()
      .close(CREATE_OPPORTUNITY_FOLLOWUP_MODAL, afterClose);

  const { opportunityId, openingActivityId } = layoutState.payload;
  const { defaults } = layoutState.payload;

  const assignFollowup = useScheduleOpportunityFollowup({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  useOnChange(
    layoutState.isOpen,
    () => {
      if (!layoutState.isOpen) {
        return;
      }

      form.setFieldsValue({
        assigneeId: null,
        dueOn: null,
        task: "",
        ...(defaults || {}),
      });
    },
    [layoutState.isOpen, form, defaults]
  );

  return (
    <AntModal
      styles={{ body: { paddingTop: "16px" } }}
      confirmLoading={assignFollowup.isLoading}
      destroyOnClose
      okText="Assign"
      onCancel={close}
      onOk={form.submit}
      style={{ top: 20 }}
      title="Schedule Followup"
      open={layoutState.isOpen}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={(values) => {
          assignFollowup.mutate({
            ...values,
            opportunityId,
            // todo: test that this is working correctly
            ...(openingActivityId ? { openingActivityId } : {}),
            ...(defaults?.integrations
              ? { integrations: defaults.integrations }
              : {}),
            ...toUnixDate(values, "dueOn"),
          });
        }}
      >
        <Form.Item label="Due On" name="dueOn" rules={[{ required: true }]}>
          <DatePicker />
        </Form.Item>
        <UserSelect
          label="Assign To"
          name="assigneeId"
          rules={[{ required: true }]}
        />
        <Form.Item label="Task" name="task" rules={[{ required: true }]}>
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>
    </AntModal>
  );
};
